"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPassRuleV2 = exports.getPassRuleV2Serializer = exports.passV2 = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const rule_1 = require("./rule");
const ruleHeader_1 = require("./ruleHeader");
const ruleType_1 = require("./ruleType");
const passV2 = () => ({ type: 'Pass' });
exports.passV2 = passV2;
const getPassRuleV2Serializer = () => (0, ruleHeader_1.wrapSerializerInRuleHeaderV2)(ruleType_1.RuleTypeV2.Pass, (0, serializers_1.struct)([]));
exports.getPassRuleV2Serializer = getPassRuleV2Serializer;
const isPassRuleV2 = (rule) => (0, rule_1.isRuleV2)(rule) && rule.type === 'Pass';
exports.isPassRuleV2 = isPassRuleV2;
//# sourceMappingURL=pass.js.map